import localForage from 'localforage';

export const initialize = () => {
  localForage.config({
    driver: localForage.LOCALSTORAGE,
    name: 'front-scp',
    description: 'Use it to save estimate data and recover by uuid',
    version: 1.0,
  });
};

export const getItem = async (key: string): Promise<any> => {
  try {
    return await localForage.getItem(key);
  } catch (error) {
    throw error;
  }
};

export const setItem = async (key: string, value: any): Promise<any> => {
  try {
    return await localForage.setItem(key, value);
  } catch (error) {
    throw error;
  }
};

export const clear = async (): Promise<void> => {
  try {
    await localForage.clear();
  } catch (error) {
    throw error;
  }
};

export const keys = async (): Promise<string[]> => {
  try {
    return await localForage.keys();
  } catch (error) {
    throw error;
  }
};
